document.addEventListener('DOMContentLoaded', () => {

  const dataEl = document.querySelector('[data-current-product]')
  if (!dataEl) return

  const data = JSON.parse(dataEl.textContent)

  const product = data.currentProduct
  const variantDefaultPlans = data.variantDefaultPlans || {}

  let originalPlanId = null

  // 🎯 SINGLE SOURCE OF TRUTH
  function getSellingPlanForVariant(variant) {
    if (!variant) return null

    const allocations = variant.selling_plan_allocations || []

    // 🟢 priority: metafield
    if (variantDefaultPlans[variant.id]) {
      const match = allocations.find(
        p => String(p.selling_plan_id) === String(variantDefaultPlans[variant.id])
      )
      if (match) return variantDefaultPlans[variant.id]
    }

    // 🔁 fallback: first available
    if (allocations.length > 0) {
      return allocations[0].selling_plan_id
    }

    return null
  }

  function getCurrentVariant() {
    const selectedOptions = []

    document.querySelectorAll('.product-option__radio:checked').forEach(el => {
      selectedOptions.push(el.value)
    })

    if (!selectedOptions.length) return null

    return product.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    )
  }

  // 🔥 SAFE Alpine getter (no widget dependency)
  function getAlpineProduct() {
    const el = document.querySelector('[x-data]')
    return el && el.__x ? el.__x.$data : null
  }

  // 🔥 Sync widget + Alpine
  function syncWidgetPlan(variant) {

    const alpineData = getAlpineProduct()

    const planId = getSellingPlanForVariant(variant)

    // ❌ NO SUBSCRIPTION → RESET STATE
    if (!planId) {

      if (alpineData) {
        alpineData.selectedPlan = 'onetime'

        if (alpineData.changeSellingPlan) {
          alpineData.changeSellingPlan({
            target: { value: '' }
          })
        }
      }

      return
    }

    // ✅ HAS SUBSCRIPTION
    const select = document.querySelector('#selling_plan')

    if (select && select.options.length) {

      if (!originalPlanId && select.value) {
        originalPlanId = select.value
      }

      if (select.value !== String(planId)) {
        select.value = planId
      }
    }

    if (alpineData) {
      if (alpineData.changeSellingPlan) {
        alpineData.changeSellingPlan({
          target: { value: planId }
        })
      }

      alpineData.selectedPlan = 'subsave'
    }
  }

  // 🔥 Wait for Recharge widget safely
  function waitForWidget(variant) {
    let attempts = 0

    function check() {
      const select = document.querySelector('#selling_plan')

      if (select && select.options.length > 0) {
        syncWidgetPlan(variant)
        return
      }

      if (attempts++ < 15) {
        setTimeout(check, 100)
      } else {
        // fallback: still sync Alpine even if widget missing
        syncWidgetPlan(variant)
      }
    }

    check()
  }

  function onVariantChange() {
    const variant = getCurrentVariant()
    if (!variant) return

    waitForWidget(variant)
  }

  // 🔁 Variant change listeners
  document.querySelectorAll('.product-option__radio').forEach(radio => {
    radio.addEventListener('change', () => {
      setTimeout(onVariantChange, 100)
    })
  })

  // 🔁 Initial load
  setTimeout(onVariantChange, 150)

  // 🚀 FLOATING ATC FIX (CAPTURE PHASE)
  document.addEventListener('submit', function(e) {

    const form = e.target

    if (!form.closest('#sticky-add-to-cart')) return

    const variantInput = form.querySelector('[name="id"]')
    if (!variantInput) return

    const variantId = variantInput.value

    const variant = product.variants.find(
      v => String(v.id) === String(variantId)
    )
    if (!variant) return

    const planId = getSellingPlanForVariant(variant)

    const alpineData = getAlpineProduct()

    // ❌ NO SUBSCRIPTION → FORCE ONETIME
    if (!planId) {

      if (alpineData) {
        alpineData.selectedPlan = 'onetime'
      }

      return
    }

    // ✅ HAS SUBSCRIPTION → INJECT
    let input = form.querySelector('[name="selling_plan"]')

    if (!input) {
      input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'selling_plan'
      form.appendChild(input)
    }

    input.value = planId

    if (alpineData) {
      alpineData.selectedPlan = 'subsave'
    }

  }, true)

})